import fromAnyToString from 'utils/converters/fromAnyToString';

const splitText = (text) => fromAnyToString(text).split(/[ ,]+/);

export default splitText;
